import PostLoginV2 from './postLoginV2'
export default PostLoginV2
